import 'cally'

import ArrowLeftIcon from "@/components/icons/ArrowLeftIcon";
import ArrowRightIcon from "@/components/icons/ArrowRightIcon";
import {buildDate} from "@/helpers";
import {useAppState} from "@/store";
import {useValidation} from "@/validation";
import {useEffect, useState} from "react";
import FieldError from "@/components/FieldError";

export default function Calendar({}) {

    const {state, setState} = useAppState()
    const {isValid, isFieldValid, invalidMessage, showErrors} = useValidation()
    const [touched, setTouched] = useState(false)

    const minDate = new Date()
    minDate.setDate(minDate.getDate() + 1);

    const handleDateChange = (e) => {
        setState(s => {
            s.estimate = null
            s.availabilities = null
            s.chosen_rate = null
            s.chosen_date = null
            s.chosen_time = null
            s.preferred_date = {...buildDate(e.target.value), flexibility: state.preferred_date?.flexibility || null}
            // s.slots = null
        })
    }

    const valid = isFieldValid('preferred_date.raw')
    const invalidMsg = invalidMessage('preferred_date.raw')
    const showError = touched && !valid && invalidMsg

    useEffect(() => {
        if (showErrors) {
            setTouched(true)
        }
    }, [showErrors])

    return (
        <>
            <calendar-date
                value={state.preferred_date?.raw || ''}
                min={minDate.toISOString().slice(0, 10)}
                formatWeekday={"short"}
                showOutsideDays={false}
                className="daisy-cally w-full"
                onchange={handleDateChange}
            >
                <div slot="previous" className={"size-[40px] lg:size-[48px] rounded-full bg-white shadow-panel flex items-center justify-center hover:bg-brand-orange transition-colors"}>
                    <ArrowLeftIcon/>
                </div>
                <div slot="next" className={"size-[40px] lg:size-[48px] rounded-full bg-white shadow-panel flex items-center justify-center hover:bg-brand-orange transition-colors"}>
                    <ArrowRightIcon/>
                </div>
                <calendar-month className={"relative rounded-lg shadow-panel p-[20px] lg:p-[32px]"}></calendar-month>
            </calendar-date>
            <input type="hidden" name={'preferred_date.raw'}/>
            {showError && (
                <div className={"text-center"}>
                    <FieldError message={invalidMsg} />
                </div>
            )}
        </>
    )
}
